import { AxiosRequestConfig } from "axios";
import mock from "../MockConfig";
import { centreData, mappingData } from "@crema/services/db/support/supportData";

// Mock API to handle centre
mock.onGet("/api/ecommerce/centre").reply((request: AxiosRequestConfig) => {
  const { search, page } = request.params;

  let centre = [...centreData]; 

  if (search) {
    centre = centre.filter(
      (centre) =>
        centre.categoryName.toLowerCase().includes(search.toLowerCase()) 
    );
  }

  return [
    200,
    {
      centreCount: centre.length,
      centre: centre.splice(page * 10, (page + 1) * 10), 
    },
  ];
});

// Mock API to handle fetching a single centre by sNo
mock.onGet("/api/ecommerce/centre/get").reply((request: AxiosRequestConfig) => {
  const { sNo } = request.params;
  if (sNo >= 1 && sNo <= 10) {
    const data = centreData.filter((item) => +item.sNo === +sNo); 
    if (data.length > 0) return [200, data[0]]; 
  }
  return [200, centreData[0]]; 
});

// Mock API to handle mapping
mock.onGet("/api/ecommerce/mapping").reply((request: AxiosRequestConfig) => {
  const { search, page } = request.params;

  let mapping = [...mappingData]; 

  if (search) {
    mapping = mapping.filter(
      (mapping) =>
        mapping.CRMCategory.toLowerCase().includes(search.toLowerCase()) 
    );
  }

  return [
    200,
    {
      mappingCount: mapping.length,
      mapping: mapping.splice(page * 10, (page + 1) * 10), 
    },
  ];
});

// Mock API to handle fetching a single centre by sNo
mock.onGet("/api/ecommerce/mapping/get").reply((request: AxiosRequestConfig) => {
  const { sNo } = request.params;
  if (sNo >= 1 && sNo <= 10) {
    const data = mappingData.filter((item) => +item.sNo === +sNo); 
    if (data.length > 0) return [200, data[0]]; 
  }
  return [200, mappingData[0]]; 
});
